import { useOffDirectCall } from "@/hooks/useOffDirectCall";
import { Box, Flex } from "@chakra-ui/react";
import {
  call,
  ColorIcon,
  colors,
  customEvent,
  HStack,
  useResponsive,
  VStack,
  EventPathType,
} from "goi_common";

import { useRouter } from "next/router";
import { useMemo } from "react";

const PrepaidBanners = ({
  eventPath = "review",
  isMobile,
  title = "미리 준비하기",
  extra,
}: {
  eventPath: keyof typeof EventPathType;
  isMobile?: boolean;
  title?: string;
  extra?: string;
}) => {
  const router = useRouter();
  const { isBiggerThanMd: breakpoint } = useResponsive();
  const isBiggerThanMd = useMemo(() => {
    return !breakpoint && !isMobile;
  }, [isMobile, breakpoint]);

  const 오인지_최소화_기능 = useOffDirectCall();

  return (
    <Flex
      flexDirection={isBiggerThanMd ? "row" : "column"}
      width="100%"
      padding="24px 20px 24px"
      margin="0 0 48px"
      background={colors.warmGray50}
      gap={isBiggerThanMd ? 10 : 6}
    >
      <VStack
        width={isBiggerThanMd ? "50%" : "100%"}
        justifyContent="space-between"
        padding={isBiggerThanMd ? "12px 24px" : "0"}
      >
        <Box className="subtitle_21_b warmGray700" padding="0 0 16px">
          [{title}]
        </Box>
        <Box className={isBiggerThanMd ? "body_18_m gray800" : "body_16_m gray800"}>
          <b>후기가 입증한 고이 패키지 미리 알아보신다면</b>
          <br />월 납입금 부담이 적은 100원 상조부터,
          <br />
          한번 납입으로 큰 혜택을 보장받을 수 있는 프리미엄 멤버십까지.
          {extra && (
            <b>
              <br />
              {extra}
            </b>
          )}
          <HStack
            width="100%"
            alignItems="center"
            justifyContent="space-between"
            gap={12}
            margin="24px 0 0"
          >
            {!(오인지_최소화_기능 && eventPath === "facility_detail") && (
              <Box
                maxWidth="100px"
                padding="8px"
                width="100%"
                textAlign="center"
                borderRadius="48px"
                border={`1px solid ${colors.warmGray800}`}
                className="subtitle_18_b gray700"
                onClick={() => {
                  customEvent({
                    newGtm: {
                      path: eventPath,
                      trigger_and_target: "pbanner-call",
                    },
                  });
                  call("1666-9784");
                }}
              >
                문의하기
              </Box>
            )}

            <Box
              padding="8px"
              width="100%"
              textAlign="center"
              borderRadius="48px"
              background={colors.warmGray750}
              className="subtitle_18_b white"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: eventPath,
                    trigger_and_target: "pbanner-uv_match_request",
                  },
                });
                router.push(`/match/request/?utm_campaign=rv_tp`);
              }}
            >
              패키지 추천받기
            </Box>
          </HStack>
        </Box>
      </VStack>
      <VStack
        gap={12}
        width={isBiggerThanMd ? "50%" : "100%"}
        justifyContent="space-between"
        padding="12px 0"
      >
        <HStack
          onClick={() => {
            customEvent({
              newGtm: {
                path: eventPath,
                trigger_and_target: "pbanner-b1_prime",
              },
            });
            router.push(`https://prime.goifuneral.co.kr/?utm_campaign=goi_rv_b1_100`);
          }}
          css={{ cursor: "pointer" }}
          width="100%"
          padding="12px 16px"
          borderRadius="6px"
          background="white"
          boxShadow="0px 0px 12px 2px rgba(0, 0, 0, 0.1)"
        >
          <VStack className="body_16_m" width="100%">
            <HStack width="100%" justifyContent="space-between" alignItems="center">
              <VStack>
                <div className="caption_11_m gray500">
                  당장은 아니지만, 미리 장례를 준비하고 싶어요.
                </div>
                <span>
                  <b>매월 100원으로 장례 준비하기</b>
                </span>
              </VStack>
              <ColorIcon name="arrow_right_small" size={16} color={colors.gray500} />
            </HStack>
          </VStack>
        </HStack>

        <HStack
          onClick={() => {
            customEvent({
              newGtm: {
                path: eventPath,
                trigger_and_target: "pbanner-b3_premium",
              },
            });

            router.push(`/promotion/service/가족장/premium-2025?utm_campaign=goi_rv_b3_premium`);
          }}
          css={{ cursor: "pointer" }}
          width="100%"
          padding="12px 16px"
          borderRadius="4px"
          background="white"
          boxShadow="0px 0px 12px 2px rgba(0, 0, 0, 0.1)"
        >
          <VStack className="body_16_m" width="100%">
            <HStack width="100%" justifyContent="space-between" alignItems="center">
              <VStack>
                <div className="caption_11_m gray500">
                  최고급 장례 물품, 계약금만 미리 내고 프리미엄 멤버십 가입
                </div>
                <span>
                  <b>1만원으로 10%할인</b> (당해 년도 가격 기준)
                </span>
              </VStack>
              <ColorIcon name="arrow_right_small" size={16} color={colors.gray500} />
            </HStack>
          </VStack>
        </HStack>
      </VStack>
    </Flex>
  );
};

export default PrepaidBanners;
